import { COOKIE_ROUTE_NAMES, COOKIE_PREVIEW_KIND } from "@/apps/cookie/cookie.routes";
import { goToField } from "@/shared/utils";

export function useCookieGoTo() {
    return {
        goToContentCookieField(fieldId) {
            goToField(COOKIE_ROUTE_NAMES.projectContent, COOKIE_PREVIEW_KIND.cookie, fieldId);
        },
        goToContentAdjustField(fieldId) {
            goToField(COOKIE_ROUTE_NAMES.projectContent, COOKIE_PREVIEW_KIND.adjust, fieldId);
        },
        goToConsentTypeField(type, fieldId) {
            goToField(
                COOKIE_ROUTE_NAMES.projectSettings,
                COOKIE_PREVIEW_KIND.adjust,
                fieldId,
                "edit",
                type
            );
        },
    };
}
